import * as actions from "./actions";
import * as constants from "./constants";
import * as selectors from "./selectors";
import container from "./container";
import reducer from "./reducer";
import sagas from "./sagas";

export default {
  actions,
  Component: container,
  constants,
  createSagas: sagas,
  reducer,
  selectors,
};
